// Dynamic import to handle Module Federation shared modules
import('./bootstrap');

export {};

